import React from 'react';
import type { PropertyPortalPublicationDisplayStatusFilter } from 'src/api/generated';
import MenuDropdown from 'src/modules/shared/components/molecules/dropdowns/menu-dropdown';
import { PageFiltersBar } from 'src/modules/shared/components/molecules/page-filters-bar';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import type { PropertyPublicationPortalFilter } from '../../schemas/property-publications-search.schema';
import {
  PROPERTY_PUBLICATION_PORTAL_FILTER_OPTIONS,
  PROPERTY_PUBLICATION_STATUS_FILTER_OPTIONS,
  getPublicationPortalFilterLabel,
  getPublicationStatusFilterLabelKey,
} from '../../utils/property-publications-filters.util';

interface PropertyPublicationsFiltersBarProps {
  publicationStatus: PropertyPortalPublicationDisplayStatusFilter;
  publicationPortal: PropertyPublicationPortalFilter;
  onPublicationStatusChange: (
    value: PropertyPortalPublicationDisplayStatusFilter
  ) => void;
  onPublicationPortalChange: (value: PropertyPublicationPortalFilter) => void;
}

export const PropertyPublicationsFiltersBar: React.FC<
  PropertyPublicationsFiltersBarProps
> = ({
  publicationStatus,
  publicationPortal,
  onPublicationStatusChange,
  onPublicationPortalChange,
}) => {
  const { t } = useI18n();
  const selectedStatusLabel = t(
    getPublicationStatusFilterLabelKey(publicationStatus)
  );
  const selectedPortalLabel = getPublicationPortalFilterLabel(
    publicationPortal,
    t
  );

  return (
    <PageFiltersBar>
      <div className="flex w-full min-w-0 flex-col gap-3 lg:flex-row lg:flex-wrap lg:items-center lg:justify-start lg:gap-2">
        <MenuDropdown
          label={selectedStatusLabel}
          items={PROPERTY_PUBLICATION_STATUS_FILTER_OPTIONS.map((option) => ({
            content: t(getPublicationStatusFilterLabelKey(option)),
            selected: option === publicationStatus,
            onClick: () => onPublicationStatusChange(option),
          }))}
          variant="secondary"
          appearance="outline"
          size="md"
          className="w-full justify-between lg:w-[220px]"
          placement="bottom-start"
        />

        <MenuDropdown
          label={selectedPortalLabel}
          items={PROPERTY_PUBLICATION_PORTAL_FILTER_OPTIONS.map((option) => ({
            content: getPublicationPortalFilterLabel(option, t),
            selected: option === publicationPortal,
            onClick: () => onPublicationPortalChange(option),
          }))}
          variant="secondary"
          appearance="outline"
          size="md"
          className="w-full justify-between lg:w-[200px]"
          placement="bottom-start"
        />
      </div>
    </PageFiltersBar>
  );
};
